<template>
    <div class="timeline-container">
        <div class="timeline-wrapper">
            <svg :width="width" :height="height" class="timeline-svg">
                <line x1="50" y1="50" :x2="width - 50" y2="50"
                    stroke="#335F7C" stroke-width="2"
                />
                <circle v-for="(event, index) in visibleEvents" :key="index"
                    :cx="getPosition(index)" cy="50" :r="event.size"
                    :fill="event.color"
                />
                <!-- TIP Timeline 中删去了时间和名字 -->
<!--                <text v-for="(event, index) in visibleEvents" :key="index + '-time'"-->
<!--                    :x="getPosition(index)" y="35"-->
<!--                    text-anchor="middle" font-size="12"-->
<!--                >-->
<!--                    {{ event.time }}-->
<!--                </text>-->
<!--                <text v-for="(event, index) in visibleEvents" :key="index + '-name'"-->
<!--                    :x="getPosition(index)" y="75"-->
<!--                    text-anchor="middle" font-size="12"-->
<!--                >-->
<!--                    {{ event.name }}-->
<!--                </text>-->
                <polygon v-if="currentPage > 0" class="arrow"
                    points="30,40 10,50 30,60"
                    fill="#335F7C"
                    @click="prevPage"
                />
                <polygon v-if="currentPage < totalPages - 1" class="arrow"
                    :points="`${width - 30},40 ${width - 10},50 ${width - 30},60`"
                    fill="#335F7C"
                    @click="nextPage"
                />
            </svg>

        </div>
    </div>
</template>

<script>
export default {
    name: "TimeLine",
    props: {
        events: {
            type: Array,
            required: true,
        },
        eventsPerPage: {
            type: Number,
            default: 7,
        },
    },
    data() {
        return {
            currentPage: 0,
            width: 800,
            height: 100,
            padding: 80,
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.events.length / this.eventsPerPage);
        },
        visibleEvents() {
            const start = this.currentPage * this.eventsPerPage;
            const end = start + this.eventsPerPage;
            return this.events.slice(start, end);
        },
    },
    methods: {
        getPosition(index) {
            const spacing = (this.width - 2 * this.padding) / (this.visibleEvents.length - 1);
            return this.padding + index * spacing;
        },
        nextPage() {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 0) {
                this.currentPage--;
            }
        },
    },
};
</script>

<style scoped>
.timeline-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.timeline-wrapper {
    width: 100%;
    overflow: hidden;
}

.timeline-svg {
    display: block;
    margin: 0 auto;
}

.arrow {
    cursor: pointer;
}

.arrow:hover {
    fill: #007bff;
}
</style>